var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-carousel',{attrs:{"height":_vm.bannerHeight+'px'}},_vm._l((_vm.bannerUrl),function(item,index){return _c('el-carousel-item',{key:index},[_c('img',{ref:"imgHeight",refInFor:true,attrs:{"src":item.value,"alt":""},on:{"load":_vm.imgLoad,"click":function($event){return _vm.onLink(item.linkUrl)}}})])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cd90904","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/carousel/carousel.vue
// module id = null
// module chunks = 